module.exports = __webpack_public_path__ + "assets/img/22_241.42714e30.jpg";